import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
    },
    fallbackLng: 'en',
    detection: {
      order: ['navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage', 'cookie'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

// Lazy-load non-English locales only when needed. Saves ~80KB on first paint.
const LAZY_LOCALES: Record<string, () => Promise<{ default: Record<string, unknown> }>> = {
  fr: () => import('./locales/fr.json'),
  es: () => import('./locales/es.json'),
  de: () => import('./locales/de.json'),
  pt: () => import('./locales/pt.json'),
  it: () => import('./locales/it.json'),
};

async function ensureLocale(lng: string) {
  const base = lng.split('-')[0];
  if (base === 'en' || i18n.hasResourceBundle(base, 'translation')) return;
  const loader = LAZY_LOCALES[base];
  if (!loader) return;
  try {
    const mod = await loader();
    i18n.addResourceBundle(base, 'translation', mod.default, true, true);
    await i18n.changeLanguage(base);
  } catch (err) {
    console.warn('Failed to load locale', base, err);
  }
}

// Load detected language asynchronously after init
if (typeof window !== 'undefined') {
  const detected = i18n.language || 'en';
  ensureLocale(detected);
}

i18n.on('languageChanged', (lng) => {
  ensureLocale(lng);
});

export default i18n;
